<template>
  <div class="bid-item">
    <!-- 头部 -->
    <div class="bid-item-header">
      <div class="bid-item-number">
        <span>编号：{{ isPreview || !value.number ? value.id : value.number }}</span>
        <span v-if="isPreview" class="state-tag state-preview">预告中</span>
        <template v-else>
          <span v-if="value.status === 1" class="state-tag state-invite">招标中</span>
          <span v-if="value.status === 2" class="state-tag state-review">评审中</span>
          <span v-if="value.status >= 3" class="state-tag state-win">已开标</span>
        </template>
      </div>
      <div v-if="!isPreview && value.status === 1" class="bid-item-deadline" :class="{ 'bid-item-end' : false }">{{ false ? '投标时间已截止' : `投标截止时间：${ value.registrationEndTime }` }}</div>
    </div>

    <!-- 标题 -->
    <div
      class="bid-item-title ellipsis--l1"
      :title="isPreview ? value.title : value.name"
      @click="detail"
    >{{ isPreview ? value.title : value.name }}</div>

    <!-- 内容 -->
    <div v-if="spliceText" class="bid-item-container" @click="detail">
      <span class="bid-item-content">{{ spliceText }}</span>
      <span v-if="spliceText.length >= contentLength" class="bid-item-detail">更多></span>
    </div>

    <!-- 底部 -->
    <div class="bid-item-footer" :style="{ marginTop: `${ actions.length === 0 ? 19 : 10 }px` }">
      <div class="bid-item-footer-container">
        <span class="bid-item-time">发布于{{ value.createTime }}</span>
        <slot name="footer" />
      </div>
      <div class="bid-item-actions">
        <template v-for="(btn, index) in actions">
          <el-button v-if="!(typeof btn.hide === 'function' ? btn.hide(value) : btn.hide)" :key="index" v-bind="btn" @click="btn.onClick(value)">{{ typeof btn.text === 'function' ? btn.text(value) : btn.text }}</el-button>
        </template>
        <el-button v-if="showDetailBtn" type="primary" @click="detail">{{ detailBtnText }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    contentLength: Number, // 截取投标内容长度，用于省略内容

    actions: {
      type: Array,
      default() {
        return []
      }
    },

    isPreview: { // 是否是预告
      type: Boolean,
      default: false
    },

    detailBtnText: {
      type: String,
      default: '查看详情'
    },

    showDetailBtn: {
      type: Boolean,
      default: true
    },

    extraDetailQuery: {
      type: Object,
      default() {
        return {}
      }
    },
    beforeDetail: {
      type: Function,
      default: () => {
        return Promise.resolve()
      }
    }
  },

  computed: {
    spliceText() {
      const { text = '', content = '' } = this.value
      const str = this.isPreview ? text : content

      if (this.contentLength > 0 && str.length > this.contentLength) {
        return `${str.substring(0, this.contentLength + 1)}.....`
      }

      return str
    }
  },

  methods: {
    /*
     * 查看更多
    */
    detail() {
      const { value, isPreview, extraDetailQuery = {}} = this

      this.beforeDetail(value)
        .then(res => {
          this.$router.push({
            name: isPreview ? 'previewDetail' : 'bidDetail',
            query: {
              id: value.projectId || value.id,
              ...extraDetailQuery
            }
          })
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.bid-item {
  position: relative;
  padding: 20px 0;
  border-bottom: 1px solid #EBEBEB;
  .bid-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 25px;
    .bid-item-number {
      display: flex;
      align-items: center;
      color: #808080;
      .state-tag {
        font-size: 12px;
        color: #fff;
        text-align: center;
        padding: 4px 7px;
        border-radius: 4px;
        margin: 0 0 0 19px;
      }
      .state-invite {
        background-color: #53BA36;
      }
      .state-preview, .state-review {
        background-color: #FF8A00;
      }
      .state-win {
        background-color: #F57979;
      }
    }
    .bid-item-deadline {
      color: #53BA36;
    }
    .bid-item-end {
      color: #B3B3B3;
    }
  }
  .bid-item-title {
    flex: 1;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
  }
  .bid-item-container {
    line-height: 26px;
    color: #808080;
    text-indent: 28px;
    margin: 18px 0 0;
    cursor: pointer;
    .bid-item-detail {
      color: #417EF7;
    }
  }
  .bid-item-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .bid-item-footer-container {
      flex: 1;
      display: flex;
      align-items: center;
      white-space: nowrap;
      .bid-item-time {
        color: #B3B3B3;
        line-height: 20px;
        padding: 0 0 0 20px;
        background-image: url('~@/assets/images/icon-clock.png');
        background-repeat: no-repeat;
        background-position: center left;
      }
    }
    .bid-item-actions {
      margin: 0 0 0 20px;
      .el-button {
        width: 126px;
        height: 40px;
        font-size: 16px;
        padding: 0;
      }
      .is-disabled {
        background-color: #DBDBDB;
      }
    }
  }
}
</style>
